/* istanbul ignore file */
import Radio from './Radio';

export default Radio;
